<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">会员中心</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="top">
      <div class="info-blcok">
        <img :src="user_info.photo" class="vip-img" />

        <div class="info-nick">
          <span class="sp-nick">{{ user_info.nick }}</span>
          <span class="sp-tip" v-if="vip_state > 0">恭喜你，已成功获得会员特权</span>
          <span class="sp-tip" v-if="vip_state == 0">升级成为会员，享受特权~</span>
          <span class="sp-tip" v-if="vip_state == -1">会员已过期</span>
        </div>
      </div>

      <div class="goto ub ub-ac2 " v-if="vip_state > 0">
        <span class="vip-type">{{ user_info.vip_tag }}</span>
        <span class="sp-tip">
          <label>{{ user_info.death_time }}</label>到期
        </span>
      </div>

      <div class="goto ub ub-ac ub-pc " style="text-align: center" v-if="vip_state == 0">
        <span class="vip-type-no">当前未开通会员</span>
      </div>

      <div class="goto ub ub-ac2" v-if="vip_state == -1">
        <span class="vip-type-no">已过期</span>
        <span class="sp-tip">
          <label>{{ user_info.death_time }}</label>过期
        </span>
      </div>
    </div>

    <div class="vip-block">
      <div  class="tip ub ub-pc ub-ac"  @click="chose_vip(1)" :class="chosed == 1 ? 'on' : ''">
        <span>VIP特权</span>
      </div>

      <div class="tip2 ub ub-pc ub-ac" @click="chose_vip(2)" :class="chosed == 2 ? 'on' : ''">
        <span>SVIP特权</span>
      </div>
    </div>

    <div v-if="chosed == 1">
      <swiper :options="swiperOption" style="min-height: 6em">
        <swiper-slide v-for="(item, index) in arr_vip" :key="index">
          <div class="ub online-least">
            <div class="comment" :class="chosed_vip != index ? 'comment-on' : ''" v-if="item.comment != ''">
              {{ item.comment }}
            </div>
            <div class="ub ub-ac2">
              <div class="top-up ub ub-ver ub-ac ub-pc" @click="chose_vip_order(index, item)" :class="chosed_vip == index ? 'on-vip' : ''">
                <span class="sp1" style="margin-top: 1.8em">{{ item.name }}</span>
                <span class="sp2" ><label class="lab">￥</label>{{ item.mny }}</span>
                <span class="sp3">{{ item.mny_old }}</span>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <div class="vip_tips ub ub-ac ub-pc">
         额外赠送{{chosed_vip_item.vip_time * 1000 + 1000}}金币(兑换方式:每天登录领取1000金币)
      </div>

      <div class="mny-block" @click="pay_vip(chosed_vip_item)">
        <span class="mny-txt">立即支付{{ chosed_vip_item.mny }}元</span>
      </div>

      <div class="vip-good">
        <span>会员权益</span>
        <img class="bg-tag" src="../assets/img/new2024/bg-all.png" alt="">
      </div>

      <div class="vip-rights">
        <ul class="power-block ub ub-ac2">
          <li class="item" @click="rules('异性匹配')">
            <img src="../assets/img/异性匹配2.png" />
            <span>异性匹配</span>
          </li>
          <li class="item" @click="rules('主页撩ta')">
            <img src="../assets/img/撩ta.png" />
            <span>主页撩ta</span>
          </li>
          <li class="item" @click="rules('最近在线')">
            <img src="../assets/img/最近在线.png" />
            <span>最近在线</span>
          </li>
          <li class="item" @click="rules('历史消息')">
            <img src="../assets/img/历史消息.png" />
            <span>历史消息</span>
          </li>
        </ul>
        <ul class="power-block ub ub-ac2">
          <li class="item" @click="rules('自定义头像')">
            <img src="../assets/img/修改头像.png" />
            <span>自定义头像</span>
          </li>
          <li class="item" @click="rules('会员专属头像')">
            <img src="../assets/img/会员专属头像.png" />
            <span>会员专属头像</span>
          </li>
          <li class="item" @click="rules('自定义昵称')">
            <img src="../assets/img/修改昵称.png" />
            <span>自定义昵称</span>
          </li>
          <li class="item" @click="rules('隐身')">
            <img src="../assets/img/隐身.png" />
            <span>隐身</span>
          </li>
        </ul>
        <ul class="power-block ub ub-ac2">
          <li class="item" @click="rules('修改备注')">
            <img src="../assets/img/修改备注.png" />
            <span>修改备注</span>
          </li>
          <li class="item" @click="rules('领金币')">
            <img src="../assets/img/金币.png" />
            <span>领金币</span>
          </li>

          <li class="item" @click="rules('会员专属头像')">
            <img v-if="false" src="../assets/img/会员专属头像.png" />
            <span v-if="false">会员专属头像</span>
          </li>
          <li class="item" @click="rules('自定义昵称')">
            <img v-if="false" src="../assets/img/修改昵称.png" />
            <span v-if="false">自定义昵称</span>
          </li>
          
        </ul>
      </div>
    </div>

    <div v-if="chosed == 2">
      <swiper :options="swiperOption" style="min-height: 6em">
        <swiper-slide v-for="(item, index) in arr_svip" :key="index">
          <div class="ub online-least">
            <div class="comment" :class="chosed_svip != index ? 'comment-on' : ''" v-if="item.comment != ''">
              {{ item.comment }}
            </div>
            <div class="ub ub-ac2">
              <div class="top-up ub ub-ver ub-ac ub-pc" @click="chose_svip_order(index, item)" :class="chosed_svip == index ? 'on-vip' : ''">
                <span class="sp1" style="margin-top: 1.8em">{{item.name}}</span>
                <span class="sp2"><label class="lab">￥</label>{{ item.mny }}</span>
                <span class="sp3">{{ item.mny_old }}</span>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <div class="vip_tips ub ub-ac ub-pc">
        额外赠送{{chosed_svip_item.vip_time * 1000 + 1000}}金币(兑换方式:每天登录领取1000金币)
      </div>

      <div class="mny-block" @click="pay_vip(chosed_svip_item)">
        <span class="mny-txt">立即支付{{ chosed_svip_item.mny }}元</span>
      </div>

      <div class="vip-good">
        <span>会员权益</span>
        <img class="bg-tag" src="../assets/img/new2024/bg-all.png" alt="">
      </div>

      <div class="vip-rights">
      <ul class="power-block ub ub-ac2">
        <li class="item" @click="rules('同城匹配')">
          <img src="../assets/img/同城匹配.png" />
          <span>同城匹配</span>
        </li>
        <li class="item" @click="rules('异性匹配')">
          <img src="../assets/img/异性匹配2.png" />
          <span>异性匹配</span>
        </li>
        <li class="item" @click="rules('主页撩ta')">
          <img src="../assets/img/撩ta.png" />
          <span>主页撩ta</span>
        </li>
        <li class="item" @click="rules('最近在线')">
          <img src="../assets/img/最近在线.png" />
          <span>最近在线</span>
        </li>
      </ul>
      <ul class="power-block ub ub-ac2">
        <li class="item" @click="rules('历史消息')">
          <img src="../assets/img/历史消息.png" />
          <span>历史消息</span>
        </li>
        <li class="item" @click="rules('自定义头像')">
          <img src="../assets/img/修改头像.png" />
          <span>自定义头像</span>
        </li>
        <li class="item" @click="rules('会员专属头像')">
          <img src="../assets/img/会员专属头像.png" />
          <span>会员专属头像</span>
        </li>
        <li class="item" @click="rules('自定义昵称')">
          <img src="../assets/img/修改昵称.png" />
          <span>自定义昵称</span>
        </li>
      </ul>

      <ul class="power-block ub ub-ac2">
         <li class="item" @click="rules('隐身')">
          <img src="../assets/img/隐身.png" />
          <span>隐身</span>
         </li>
        <li class="item" @click="rules('修改备注')">
          <img src="../assets/img/修改备注.png" />
          <span>修改备注</span>
        </li>
        <li class="item" @click="rules('领金币')">
            <img src="../assets/img/金币.png" />
            <span>领金币</span>
          </li>
        <li class="item" @click="rules('会员专属头像')">
          <img v-if="false" src="../assets/img/会员专属头像.png" />
          <span v-if="false">会员专属头像</span>
        </li>
      </ul>

      <ul class="power-block ub" v-if="false">
        <li class="item">
          <img src="../assets/img/头像框.png" />
          <span>头像框</span>
        </li>
      </ul>
      </div>

    </div>
    <div class="pay-note">
      <p>
        <span class="tag"></span><span>虚拟产品购买后不可退换</span>
      </p>
      <p>
        <span class="tag"></span><span>未成年请在家长陪同下充值</span>
      </p>
      <p>
        <span class="tag"></span><span>为了保障您的资金安全，当前只支持微信环境下支付</span>
      </p>
    </div>

    <dlg ref="myForm" @formBehavior="formBehaviorFun"></dlg>
  </div>
</template>

<script>
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "../components/Form.vue";
export default {
  components: {
    dlg: Form,
  },
  data() {
    return {
      user_info: {
        nick: "仙女爷爷",
        photo: "../assets/img/vip.png",
      },

      vip_state: 0,

      arr_vip: [],
      arr_svip: [],

      chosed: 1,
      chosed_vip: 2,
      chosed_svip: 2,
      chosed_vip_item: {},
      chosed_svip_item: {},

      total_mny: 0,
      vip_first: false,
      svip_first: false,

      swiperOption: {
        pagination: ".swiper-pagination",
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: -25,
      },
      theme_dark: false,
      
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
    this.init_page_pay();
  },
  methods: {
    ...mapMutations(["get", "post", "WxConfig", "WxPay"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var uid = this.$store.state.uid;
      var self = this;

      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.user_info = u;

          if (u.vip_level > 0) {
            self.vip_state = 1;
          } else {
            if (u.death_time != "1900-01-01 00:00:00") {
              self.vip_state = -1;
            }
          }
        },
      });

      //加载配置数据
      self.get({
        url: "/App/GetCnfigMem/?uid=" + uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          var arr_vip = [];
          var arr_svip = [];
          for (var i = 0; i < data.length; i++) {
            if (data[i]["vip_type"] == "VIP") {
              arr_vip.push(data[i]);
            }
            if (data[i]["vip_type"] == "SVIP") {
              arr_svip.push(data[i]);
            }
          }
          self.arr_vip = arr_vip;
          self.arr_svip = arr_svip;

          //设置默认选中(推荐设为选中)
          for (var i = 0; i < arr_vip.length; i++) {
            if (arr_vip[i]["comment"] == "推荐") {
              self.chosed_vip = i;
              self.chosed_vip_item = arr_vip[i];
              break;
            }
          }
          for (var i = 0; i < arr_svip.length; i++) {
            if (arr_svip[i]["comment"] == "推荐") {
              self.chosed_svip = i;
              self.chosed_svip_item = arr_svip[i];
              break;
            }
          }

         
        },
      });

      //判断是否首次购买
      self.get({
        url: "/App/GetVip_AttachInfo/?uid=" + uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.total_mny = parseFloat(data.total_mny);
          self.vip_first = data.vip_first == "True";
          self.svip_first = data.svip_first == "True";
        },
      });
    },

    chose_vip(vip_tag) {
      this.chosed = vip_tag;
    
    },
    chose_vip_order(vip_type, item) {
      //console.log(JSON.stringify(item));
      if (this.vip_first == true && item.comment == "新用户专享") {
        this.$toast.center("此为新用户专享功能~");
        return false;
      }
      this.chosed_vip_item = item;
      this.chosed_vip = vip_type;

    
    },
    chose_svip_order(vip_type, item) {
      //console.log(JSON.stringify(item));
      if (this.svip_first == true && item.comment == "新用户专享") {
        this.$toast.center("此为新用户专享功能~");
        return false;
      }
      this.chosed_svip_item = item;
      this.chosed_svip = vip_type;
    },
    rules(txt) {
      var h = "";
      switch (txt) {
        case "异性匹配":
          h ='<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员，首页【异性匹配】按钮启用，每天无限次匹配机会，100%匹配异性，只做异性匹配哦~</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/1.png"/></div>';
          break;

        case "主页撩ta":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员，首页最新上线的用户 【撩 ta】按钮开启，可随意撩 ta，每天不限次数~</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/2.png"/></div>';
          break;

        case "最近在线":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员，消息页面【最近在线】用户可随意选中聊天，每天不限次数~</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/3.png"/></div>';
          break;

        case "历史消息":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员，聊天界面【历史消息】可查看，任何用户全部历史消息永久保存，可供查看</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/4.png"/></div>';
          break;

        case "自定义头像":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员，可自定义上传头像，做不一样的自己</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/5.png"/></div>';
          break;

        case "会员专属头像":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员，拥有专属头像，处处彰显不一样的自己</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/6.png"/></div>';
          break;

        case "自定义昵称":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员，可自定义昵称，不限次数无限修改</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/7.png"/></div>';
          break;

           case "同城匹配":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为超级会员，可优先匹配同城异性，会优先按照由近及远的顺序进行匹配</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/8.png"/></div>';
          break;

          case "隐身":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员可设置隐身，通过该功能可以修改自己对外显示的魅力值和豪气值</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/10.png"/></div>';
          break;

          case "修改备注":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员可不限次数修改备注，你所关心的人再也不会记不住啦</span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/9.png"/></div>';
          break;

          case "领金币":
          h = '<div class="ub ub-ac ub-pc ub-ver"><div style="width: 100%; text-align: left;margin-bottom: .5em;border-radius: 0.5em;"><span style="display: inline-block; font-size: 0.9rem; color: #888; padding: .2em .3em;">成为会员，每日可免费领取1000金币（即购买会员赠送的金币），领取位置：我的--->我的金币--->领取，或者赚金币页面也可领取 </span></div><img style="width: 100%;  border-radius: 0.5em" src="http://appdata.jscx666.cn/img/other/18.png"/></div>';
          break;
      }

      this.$refs.myForm.show(h, {
        type: "confirm",
        confirmText: "立即开通",
        titleText: txt,
        data: "",
      });
    },

    //======================================//
    init_page_pay() {
      this.WxConfig({url:window.location.href});
    },

    pay_vip(item) {
      //启动动画
      this.$loading("支付中...");

      //获取 openid
      var openid = this.$store.state.openid;
      if (!openid) {
        if ($cookies.isKey("openid")) {
          openid = $cookies.get("openid");
        }
      }

      //获取 order_from
      var order_from = "";
      var client = this.$store.state.client;
      if (client.is_wx) {
        if (openid) {
          order_from = "微信公众号支付";
        } else {
          order_from = "微信环境无openid";
        }
      } else {
        order_from = "非微信环境";
        //给弹出提示
        this.Show_GuanzhuWx();
      }

      var uid = this.$store.state.uid;

      var self = this;
      var send_data = {
        order_name: item.name + item.vip_type,
        order_mny: item.mny,
        vip_type: item.vip_type,
        vip_time: item.vip_time,
        comment: item.lv,
        uid: uid,
        order_from: order_from,
        out_id: openid,
        order_type: "购买会员",
        order_type2:"正常购买"
      };

      var sendData = JSON.stringify(send_data);
      //console.log(sendData);

      var parm_data = {
        url: "/App/Create_Order",
        data: { data: sendData },
        success: function (data_serve) {
          //消掉动画
          self.$loading.close();
          if (data_serve.state != "1") {
            self.$toast.center("订单生成失败,请重新下单");
            return false;
          }
          var data_pay = {
            body: send_data.order_name,
            out_trade_no: data_serve.msg,
            totalMoney: item.mny * 100,
            openid: openid,
          };
          //console.log(JSON.stringify(data_pay));
          self.checkUid();
          self.pay(data_pay);
        },
        error: function (data_serve) {
          //消掉动画
          self.$loading.close();
        },
      };

      self.post(parm_data);
    },

    pay(data) {
      var self = this;
      var strSend = JSON.stringify(data);
      var data = {
        strSend: strSend,
        success: function (res) {
          //提示支付成功,刷新用户信息
          setTimeout(() => {
            var uid = self.$store.state.uid;
            self.act_reload_userinfo({
              uid: uid,
              success: function (u) {
                self.$toast.center("购买成功~");
                self.user_info = u;

                if (u.vip_level > 0) {
                  self.vip_state = 1;
                }
              },
            });
          }, 500);
        },
        cancel: function (res) {},
        fail: function (res) {},
      };

      //检测是否微信环境，是微信环境进行微信支付
      var client = this.$store.state.client;
      if (client.is_wx) {
        this.WxPay(data);
      }
    },

    Show_GuanzhuWx() {
      var qrcode_url = require("../assets/img/qrcode_xhc.jpg");
      var gzh_name = "小火柴";
      //加载dic信息
      var sysdic = this.$store.state.sysdic;
      if (sysdic) {
        qrcode_url = sysdic.wx_gzh_qrcode;
        gzh_name = sysdic.wx_gzh_name;
      }
      var h =
        '<div class="dlg-note">为了保证您的资金安全，当前只支持微信环境下支付，请先关注微信公众号<div>' +
        '<div class="ub ub-ac ub-pc dlg-img"><img src="' +qrcode_url +'" /></div>';
      this.$refs.myForm.show(h, {
        type: "alert",
        confirmText: "微信扫描上方二维码",
        titleText: "温馨提示",
        data: "",
      });
    },

    formBehaviorFun(type, data) {
      if (type == "clickConfirm") {
      }
    },

    checkUid() {
      var uid = this.$store.state.uid;
      //支付检测uid
      if (uid == null || uid == "" || uid == "undefined") {
        var keys = this.$cookies.keys();
        for (var i in keys) {
          this.$cookies.remove(keys[i]);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #fff;
  .nav-top {
    background-color: #8A61FF;
  }
}

.top {
  border-bottom-left-radius: 24%;
  border-bottom-right-radius: 24%;
  padding: 1.1rem 0 0 0;
  background-color: #8A61FF;
  background-image: linear-gradient(to bottom, #8A61FF 13%, #FE9CC0 91%);
  display: flex;
  align-items: center;
  flex-direction: column;
  .info-blcok {
    display: flex;
    width: 86%;
    margin-bottom: 1px;
    .vip-img {
      width: 3rem;
      height: 3rem;
      margin: 0.5rem;
      pointer-events: none;
      border-radius: 50%;
    }
    .info-nick {
      display: flex;
      flex-direction: column;
      margin-left: 0.3rem;
      span {
        color: #fff;
        display: inline-block;
      }
      .sp-nick {
        font-size: 0.95rem;
        margin: 0.7rem 0 0.2rem 0;
      }
      .sp-tip {
        font-size: 0.75rem;
        color: #fff;
      }
    }
  }
  .goto {
    margin-top: 0.5rem;
    padding: 0.8rem 1.5rem;
    align-items: center;
    background-color: #ffdfb8;
    border-radius: 0.5rem;
    width: 75%;
    height: 2.6rem;
    border-bottom-left-radius: 22%;
    border-bottom-right-radius: 22%;
    .vip-type {
      font-size: 1.2rem;
      font-weight: 600;
      background-image: linear-gradient(135deg, red, blue);
      -webkit-background-clip: text;
      color: transparent;
    }
    .vip-type-no {
      font-size: 1rem;
      color: #aaa;
    }
    .sp-tip {
        font-size: 0.75rem;
        color: #888;
    }
  }
}

.vip-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2rem 1rem 1.5rem 1rem;
  color: #666;
  .tip {
    border-top: 1px solid #666;
    border-left: 1px solid #666;
    border-bottom: 1px solid #666;
    height: 3rem;
    width: 50%;
    border-radius: 1.5rem 0 0 1.5rem;
  }
  .tip2 {
    border-top: 1px solid #666;
    border-right: 1px solid #666;
    border-bottom: 1px solid #666;
    height: 3rem;
    width: 50%;
    border-radius: 0 1.5rem 1.5rem 0;
  }
  .on {
    color: white !important;
    background-color: rgb(186, 97, 255);;
    border-color: rgb(186, 97, 255);;
  }
}

.online-least {
  padding: 1rem 0.8rem;
  min-height: 4rem;
  .comment {
    position: absolute;
    font-size: 0.5rem;
    color: #fff;
    background-color: rgb(186, 97, 255);
    padding: 0.3rem 0.8rem;
    border-radius: 0.5rem 0 0.5rem 0;
  }
  .comment-on {
    background-color: #dcdcdc;
    color: #fff;
  }
  .top-up {
    position: relative;
    border: 1px solid #dcdcdc;
    line-height: 1.5rem;
    padding: 0.3rem 0.8rem;
    border-radius: 0.5rem;
    width: 4.3rem;
    height: 6.2rem;
    .sp1 {
      font-size: 0.85rem;
      margin-left: 0.8rem;
      color: #111;
    }
    .sp2 {
      font-size: 1.5rem;
      font-weight: 600;
      color: #111;
    }
    .lab {
      font-size: 0.5rem;
    }
    .sp3 {
      text-decoration: line-through;
      color: #dadada;
      margin-left: 0.5rem;
      font-size: 0.9rem;
    }
  }
  .on-vip {
    border: 1px solid rgb(186, 97, 255);
    line-height: 1.5rem;
    padding: 0.8rem;
    border-radius: 0.5rem;
    width: 4.3rem;
    height: 5.2rem;
  }
}

.vip_tips {
  font-size: 0.7rem;
  color: rgb(186, 97, 255);;
}

.mny-block {
  padding: 0.5rem 0.8rem;
  text-align: center;
  .mny-txt {
    display: block;
    font-size: 0.93rem;
    padding: 0.45rem 0;
    border-radius: 1.2rem;
    color: #fff;
    height: 1.55rem;
    line-height: 1.5rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  }
}

.vip-good {
  margin-left: 0.8rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  font-weight: bold;
  .bg-tag {
    width: 0.5rem;
    height: 0.5rem;
    margin-left: 0.1rem;
    margin-bottom: 0.7rem;
  }
}

.vip-rights {
  background-color: #EFEFEF;
  margin: 0 0.8rem;
  border-radius: 0.5rem;
  .power-block {
    padding: 0 0.8rem 0.5rem 0.8rem;
    .item {
      width: 5rem;
      margin-top: 0.8rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 1.8rem;
        height: 1.8rem;
        display: inline-block;
        border-radius: 0.3rem;
        pointer-events: none;
      }
      span {
        margin-top: 0.8rem;
        font-size: 0.7rem;
        display: inline-block;
        color:#333;
      }
    }
  }
}

.pay-note {
    padding-bottom: 0.5rem;
    margin-top: .5rem;
    margin-left: 1rem;
    color: #999;
    font-size: 0.75rem;
    .tag {
      display: inline-block;
      width: 0.6rem;
      height: 0.6rem;
      background-color: #999;
      margin-right: 0.2rem;
      border-radius: 50%;
    }
}

.swiper-pagination {
  bottom: 0px !important;
}

.container-dark {
  background-color: #2F2E33;
  .nav-top {
    background-color: #3c296e;
  }
  .top {
    background-image: linear-gradient(to bottom, #3c296e, #5f3b48);
    .goto {
        background-color: #b67d37;
        .vip-type-no {
          color: #fff;
        }
        .sp-tip {
            color: #fff;
        }
      }
  }
  .vip-block {
    .tip {
      border-top: 1px solid #666;
      border-left: 1px solid #666;
      border-bottom: 1px solid #666;
    }
    .tip2 {
      border-top: 1px solid #666;
      border-right: 1px solid #666;
      border-bottom: 1px solid #666;
    }

  }
  .online-least {
    .comment-on {
      background-color: #FDFDFD;
      color: #333;
    }
    .top-up {
      .sp1 {
        color: #fff;
      }
      .sp2 {
        color: #fff;
      }
    }
  }
  .vip-good {
    span {
      color: #fff;
    }
  }
  .vip-rights {
    background-color: #2c2b30;
    .power-block {
      .item {
        span {
          color: #FDFDFD;
        }
      }
    }
  }
}
</style>